import { JSX } from "react";

interface ServiceProps {
    serviceName: string;
    services: Array<string>;
}

export default function Service({ serviceName, services }: ServiceProps): JSX.Element {
    return (
        <div className="col-md-3">
            <div className="card h-100 shadow-sm p-4">
                <h5 className="card-title mb-3">{serviceName}</h5>
                <ol className={"text-start"}>
                    {
                        services.map(
                            (service: string, index: number): JSX.Element => <li key={index}>{service}</li>
                        )
                    }
                </ol>
            </div>
        </div>
    );
};